import type { MediaDimensions } from './types';

export function calculateAspectRatio(dimensions: MediaDimensions): number | undefined {
	const { intrinsicHeight, intrinsicWidth } = dimensions;

	if (intrinsicHeight === 0) {
		return undefined;
	}

	return intrinsicWidth / intrinsicHeight;
}
